module.exports = __webpack_public_path__ + "img/privacy_clean.cd8dabd5.png";